import React from "react";
import { useLocation } from "react-router-dom";

const TableOfContents = ({ routes }) => {
  const location = useLocation();
  const id = location.pathname.split("/")[1];
  return (
    <div className="d-block d-lg-none">
      <div
        className="accordion accordion-flush"
        id={`accordionFlushExample${id}`}
      >
        <div className="accordion-item accordion-box-shadow border">
          <h2 className="accordion-header p-4 accordion-box-shadow" id={id}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#flush-collapseOne${id}`}
              aria-expanded="false"
              aria-controls={`flush-collapseOne${id}`}
            >
              <span className="fs-14 gilroy-bold text-orange-ryb">
                Table of contents
              </span>
            </button>
          </h2>
          <div
            id={`flush-collapseOne${id}`}
            className="accordion-collapse collapse"
            aria-labelledby={id}
            data-bs-parent={`#accordionFlushExample${id}`}
          >
            <div className="accordion-body ms-4">
              <ul className="list-style-none fs-14">
                {routes?.map((route, index) => (
                  <li key={index} className="py-4">
                    <a
                      href={route.link}
                      className="text-decoration-none fs-16 text-orange-ryb gilroy-bold"
                    >
                      {route.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableOfContents;
